import {BrowserModule} from '@angular/platform-browser';
import {NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ApplicationRef, DoBootstrap} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AnalyticsModule} from '@wdpr/angular-analytics';
import {sprintf} from 'sprintf-js';
import {environment} from '../environments/environment';
import {AppComponent} from './app.component';
import {AvailabilitySelectorComponent} from './features/availability-selector/availability-selector.component';
import {AvailabilityCalendarComponent} from './features/availability-calendar/availability-calendar.component';
import {RequestExecutor} from './shared/libraries/request-executor';
import {ApiService} from './shared/services/api.service';
import {TranslationsService} from './shared/services/translations.service';
import {ConfigService} from './shared/services/config.service';
import {CookieService} from 'ngx-cookie-service';
import {TranslatePipe} from './shared/pipes/translate.pipe';
import {DateHandler} from './shared/libraries/date-handler';
import {LocaleHandler} from './shared/libraries/locale-handler';
import {SegmentHandler} from './shared/libraries/segment-handler';
import {ConversationId} from './shared/libraries/conversation-id';
import {AnalyticsHandler} from './shared/libraries/analytics-handler';
import { AuthService } from './shared/services/auth.service';
import {Utils} from './shared/libraries/utils';
import {Constants} from './shared/constants';
@NgModule({
    declarations: [
        AppComponent,
        AvailabilitySelectorComponent,
        AvailabilityCalendarComponent,
        TranslatePipe
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        AnalyticsModule
    ],
    providers: [
        ConversationId,
        RequestExecutor,
        ApiService,
        DateHandler,
        LocaleHandler,
        SegmentHandler,
        AnalyticsHandler,
        CookieService,
        ConfigService,
        AuthService,
        {
            provide: APP_INITIALIZER,
            useFactory: (config: ConfigService) => () => {
                return config.loadConfig()
                    .then((result: any) => {
                        return result;
                    })
                    .catch((err) => {
                        return err;
                    });
            },
            deps: [ConfigService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (translations: TranslationsService) => () => {
                return translations.loadTranslations()
                    .then((result: any) => {
                        return result;
                    })
                    .catch((err) => {
                        return err;
                    });
            },
            deps: [TranslationsService],
            multi: true
        },
        {
            provide: 'PAGE_KEY_URL_ENDPOINT',
            useFactory: (localeHandler: LocaleHandler) => {
                return sprintf(
                    `${environment.apiConfiguration.basePath}${environment.apiConfiguration.paths.pageKeyData}`,
                    [localeHandler.getCurrentPreferredLanguage()]
                );
            },
            deps: [LocaleHandler]
        },
        {
            provide: 'PAGE_KEY_TEMPLATE',
            useValue: ['brand','locale','pageId']
        }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule implements DoBootstrap {
    private config: any;
    constructor(
        private _authService: AuthService,
        private _configService: ConfigService,
        private _segmentHandler: SegmentHandler
    ) { 
    }
    /**
     * Bootstrap the application if the user is authenticated
     * @param {ApplicationRef} appRef The application reference
     *
     * @returns {void}
     */
    ngDoBootstrap(appRef: ApplicationRef): void {

        //for local development use:
        //.setRequestHeaders(
        //     {
        //         ...{'Authorization': 'bearer token'}
        //     }
        // )
        this.config = this._configService.getConfig();
        const segments = Utils.getValueFromQueryParam(Constants.PARAM_SEGMENTS).split(',');
        const isCast = this._segmentHandler.isCast(segments, this.config.castSegments);

            if (Utils.isToggleOn(this.config.toggles.enableCastSegments) && isCast) {
            this._authService
            .setRequestHeaders()
            .setRequestParams(
                {segments}
            )
            .validateGuest().subscribe(
                (response: any) => {
                    appRef.bootstrap(AppComponent);
                },
                (err) => {
                    if (err && err.status === 401) {
                        this._authService.redirectToLoginPage();
                    }
                }
            );
        } else {
            appRef.bootstrap(AppComponent);
        }
    }
}
